// @ts-check

/**
 * // https://github.com/whatwg/fetch/issues/905
 * @param {AbortSignal[]} signals
 */
export function anySignal(signals) {
  const controller = new AbortController()

  function onAbort() {
    controller.abort()

    // Cleanup
    for (const signal of signals) {
      signal.removeEventListener("abort", onAbort)
    }
  }

  for (const signal of signals) {
    if (signal.aborted) {
      onAbort()
      break
    }
    signal.addEventListener("abort", onAbort)
  }

  return controller.signal
}

export class RequestError extends Error {
  name = "RequestError"

  /**
   * @param {{
   *   message: string,
   *   request?: any,
   *   response?: Partial<import('./types').FetchResponse<any>>
   * }} param0
   */
  constructor({message, request, response}) {
    super(message)
    this.request = request
    this.response = response
  }
}

/**
 * @param {string=} name
 */
export function throwNotFoundError(name = "Object") {
  const message = `${name} not found`
  throw new RequestError({
    message,
    request: undefined,
    response: {
      status: 404,
      statusText: "404",
      data: {
        error: message,
        success: false,
      },
      headers: {},
    },
  })
}

/**
 * @param {import('./types').FetchResponse<any>} fetchResponse
 */
export function throwRequestError(fetchResponse, requestParams = {}) {
  const error = new RequestError({
    message:
      fetchResponse.data.error ||
      `Request failed with status code ${fetchResponse.status}`,
    request: requestParams,
    response: fetchResponse,
  })

  throw error
}
